import dayjs from "dayjs";
import React, { useState } from "react";
import QRCode from "react-qr-code";
import Button from "../../../../components/ui/Button/Button";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import Modal from "../../../../components/ui/Modal/Modal";
import { convertSecondsToDate } from "../../../../helper/formatDate/formate-date";
import { Form } from "../../../../utils/Form/Form";

export default function QRForm({
  onSubmit,
  productCodeQR,
  product,
  defaultValue,
}) {
  const isModeEdit = Object.keys(defaultValue ?? {})?.length !== 0;

  const [manufacDate, setManufacDate] = useState(
    defaultValue?.manufacDate ? dayjs(defaultValue?.manufacDate) : null
  );
  const [expireDate, setExpireDate] = useState(
    defaultValue?.expireDate ? dayjs(defaultValue?.expireDate) : null
  );
  const [lotNo, setLotNo] = useState(defaultValue?.lotNo ?? "");
  const [qrNo, setQrNo] = useState(defaultValue?.qrNo ?? "");
  const [enteredQRValue, setEnteredQRValue] = useState(
    defaultValue?.qrNo ?? ""
  );

  const onChangeQrNo = (e) => {
    setQrNo(e.target.value);
  };

  const onChangeLotNo = (e) => {
    setLotNo(e.target.value);
  };

  const onChangeManufacDate = (value) => {
    setManufacDate(value);
  };

  const onChangeExpireDate = (value) => {
    setExpireDate(value);
  };
  const onSubmitQRValue = (qrValue) => {
    setEnteredQRValue(qrValue);
  };
  return (
    <Form
      onSubmit={(data) =>
        onSubmit({
          ...data,
          id: defaultValue?.id,
          manufacDate: manufacDate,
          expireDate: expireDate,
          lotNo: lotNo,
        })
      }
      options={{
        defaultValue: {
          lotNo: defaultValue?.lotNo,
          manufacDate: defaultValue?.manufacDate,
          expireDate: defaultValue?.expireDate,
          qrNo: defaultValue?.qrNo,
          id: defaultValue?.id,
        },
      }}
    >
      {({}) => {
        const formValues = {
          id: defaultValue?.id,
          manufacDate: manufacDate,
          expireDate: expireDate,
          lotNo: lotNo,
        };
        const isFormEmpty =
          !manufacDate || !expireDate || !lotNo || !enteredQRValue;
        const payload = isModeEdit
          ? {
              ...formValues,
              id: defaultValue?.id,
              manufacDate: manufacDate,
              expireDate: expireDate,
              lotNo: lotNo,
              qrNo: enteredQRValue,
            }
          : {
              ...formValues,
              manufacDate: manufacDate,
              expireDate: expireDate,
              lotNo: lotNo,
              qrNo: enteredQRValue,
            };
        return (
          <>
            <div className="flex items-center justify-between">
              <div className="w-full">
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    상품번호
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.productGroup?.productNo || "-"}
                  </div>
                </div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    카테고리
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.productGroup?.productGroupCategory?.name}
                  </div>
                </div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    상품명
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.name}
                  </div>
                </div>{" "}
                <div className="flex border-x border-t border-b border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    REF(상품코드)
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.ref}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <h2 className="text-[14px] font-bold mb-4">QR 정보</h2>
              <div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
                    <span>QR코드 입력정보</span>
                  </div>
                  <div className="w-full">
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        LOT
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="w-[75%]">
                          <input
                            type="text"
                            className="border rounded-[4px] w-full h-9 text-[12px] p-2"
                            placeholder="LOT 번호를 입력해주세요."
                            onChange={onChangeLotNo}
                            name="lotNo"
                            defaultValue={
                              isModeEdit ? lotNo ?? defaultValue?.lotNo : lotNo
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        제조일자
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="w-[75%]">
                          <InputDate
                            placeholder="제조일자를 선택해주세요."
                            onChange={onChangeManufacDate}
                            value={manufacDate ? dayjs(manufacDate) : null}
                            width="w-full"
                            height="h-9"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        유효일자
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="w-[75%]">
                          <InputDate
                            placeholder="유효일자를 선택해주세요."
                            onChange={onChangeExpireDate}
                            value={expireDate ? dayjs(expireDate) : null}
                            width="w-full"
                            height="h-9"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
                    <span>QR번호 등록정보</span>
                  </div>
                  <div className="w-full">
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        QR번호
                      </div>

                      <div className="flex gap-0 items-center bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="w-[75%] flex-none">
                          <input
                            type="text"
                            className="border rounded-[4px] w-full h-9 text-[10px] p-2"
                            placeholder="QR번호를 입력해주세요."
                            value={qrNo}
                            onChange={onChangeQrNo}
                          />
                        </div>
                        <div className="w-[25%] ml-2">
                          <Modal
                            description={
                              <span>
                                입력한 정보로 QR을 등록하시겠습니까?
                                <br />
                                입력 된 번호로 QR이 생성되오니, 상품 QR번호와
                                동일한지 확인해주세요.
                              </span>
                            }
                            hasCancel={false}
                            onSubmit={() => onSubmitQRValue(qrNo)}
                          >
                            <Button
                              type="button"
                              width="w-[4.5rem]"
                              className="h-9 bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey"
                              text="등록"
                            />
                          </Modal>
                        </div>
                      </div>
                    </div>

                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        QR이미지
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="rounded-md border border-primary-grey w-24 h-24 flex items-center justify-center">
                          {enteredQRValue !== "" ? (
                            <QRCode
                              size={256}
                              style={{
                                height: "auto",
                                maxWidth: "100%",
                                width: "100%",
                                padding: "6px",
                              }}
                              value={enteredQRValue}
                              viewBox={`0 0 256 256`}
                            />
                          ) : (
                            <div className="text-[#CCCCCC]">미리보기</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="my-4" />
            <div className="flex justify-end">
              <Modal
                description={
                  isModeEdit ? (
                    <span>
                      입력한 정보로 변경을 완료하시겠습니까?
                      <br />
                      변경 된 정보로 Admin 및 APP/WEB의 상품 판매정보와 재고관리
                      등 모든
                      <br />
                      연동 구역에 업데이트 됩니다.
                    </span>
                  ) : (
                    <span>
                      입력한 정보로 등록을 완료하시겠습니까?
                      <br /> 등록 된 정보로 Admin 및 APP/WEB의 상품 판매정보와
                      재고관리 등 모든
                      <br />
                      연동 구역에 등록됩니다.
                    </span>
                  )
                }
                onSubmit={() => onSubmit(payload)}
              >
                <Button
                  type="button"
                  isDisabled={isFormEmpty && !isModeEdit}
                  primary
                  text="등록완료"
                />
              </Modal>
            </div>
          </>
        );
      }}
    </Form>
  );
}
